import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@mui/material";
import { useTranslation } from "react-i18next";

type LowerHandDialogProps = {
  open: boolean;
  deviceId: string;
  isLoweringHand: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export default function LowerHandDialog({
  open,
  deviceId,
  isLoweringHand,
  onCancel,
  onConfirm
}: LowerHandDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="lower-hand-dialog-title"
      aria-describedby="lower-hand-dialog-description"
    >
      <DialogTitle id="lower-hand-dialog-title">{t("lower hand")}</DialogTitle>
      <DialogContent sx={{ pt: 3, pb: 2, textAlign: "center" }}>
        <DialogContentText id="lower-hand-dialog-description">
          {t(
            "are you sure you want to lower the hand for workstation {{deviceId}}?",
            { deviceId }
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
        <Button onClick={onCancel} disabled={isLoweringHand} color="inherit">
          {t("cancel")}
        </Button>
        <Button
          onClick={onConfirm}
          color="primary"
          variant="contained"
          disabled={isLoweringHand}
          autoFocus
        >
          {isLoweringHand ? t("lowering...") : t("lower hand")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
